import style from './express-workout-home-card-list.module.scss'
import { WorkoutPopup } from '../programmes/programme-workout-popup'
import { WorkoutCardTrending } from '../ui/workout-card/workout-card-trending'
import React, { useContext, useState } from 'react'
import { Container } from 'react-bootstrap'
import { SessionContext } from 'src/context/session-context'
import { Workout } from 'src/dao/core-dao'

const ExpressWorkoutHomeCard = ({
  workout,
  isLarge,
  selectWorkout,
}: {
  workout: Workout
  isLarge?: boolean
  selectWorkout: () => void
}): React.ReactElement => {
  const { completedWorkoutIds } = useContext(SessionContext)

  return (
    <div className={isLarge ? style.largeCardWrapper : undefined}>
      <WorkoutCardTrending
        workout={workout}
        isCompleted={completedWorkoutIds.has(workout.id)}
        onAction={selectWorkout}
        className={`${style.workoutCard} ${isLarge ? style.largeCard : style.smallCard} aspect-auto`}
      />
    </div>
  )
}

export const ExpressWorkoutHomeCardList = ({ workouts }: { workouts: Workout[] }): React.ReactElement => {
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | undefined>(undefined)

  const verticalCard = workouts[0]
  const gridCards = workouts.slice(1)

  // The layout is "one large card plus a grid", so it has no meaning without a first
  // workout — and `ExpressWorkoutHomeCard` would dereference `workout.id` on
  // `undefined` and take the whole page down with an error boundary. Callers are
  // expected to skip the section entirely when the list is empty (see
  // `express-workouts.tsx`); this is the belt to that braces, because the component is
  // shared and a crash here is never a proportionate response to no data.
  if (!verticalCard) return <></>

  return (
    <Container fluid className="px-0">
      <div className={style.container}>
        <div className={style.largeCardColumn}>
          <ExpressWorkoutHomeCard workout={verticalCard} isLarge={true} selectWorkout={() => setSelectedWorkout(verticalCard)} />
        </div>
        <div className={style.smallCardsColumn}>
          <div className={style.masonryGrid}>
            {gridCards.map((card, index) => (
              <div key={index} className={style.masonryItem}>
                <ExpressWorkoutHomeCard workout={card} isLarge={false} selectWorkout={() => setSelectedWorkout(card)} />
              </div>
            ))}
          </div>
        </div>
        <WorkoutPopup
          setOnClose={() => setSelectedWorkout(undefined)}
          selectedWorkout={selectedWorkout}
          startWorkoutLink={selectedWorkout ? `/workouts/${selectedWorkout?.id}` : undefined}
        />
      </div>
    </Container>
  )
}
